@if (foto; as url) {
  <img class="avatar-pessoa" [style.width.px]="tamanho" [style.height.px]="tamanho" [src]="url" [alt]="pessoaAtual()?.nome ?? ''"
       (error)="fotoComErro.set(true)" />
} @else {
  <span class="avatar-pessoa avatar-pessoa-inicial" [style.width.px]="tamanho" [style.height.px]="tamanho"
        [style.font-size.px]="tamanho * 0.45" [attr.aria-label]="pessoaAtual()?.nome ?? ''">{{ inicial }}</span>
}
